<script>
    import { onMount } from 'svelte';
    import {cssVariables} from '../utils/CSSVariables';

    export let countDown;
    let currentCountDown = 0;
    let countDownInterval;
    let onTimeoutAction;
    let circleProgress;

    const FULL_CIRCLE = 113;

    onMount(() => {        
        (async () => {})();
        return destroy;
    });

    function destroy()
    {
        if (countDownInterval)
            clearInterval(countDownInterval);
    }

    export function setCountDown(value, onTimeout, timeLeft = 0)
    {
        countDown = value;
        currentCountDown = timeLeft > 0 ? timeLeft : value;
        onTimeoutAction = onTimeout;

        setTimeout(updateTimer, 50);    //delay a bit to allow for the creation of the SVG before the first update
        countDownInterval = setInterval(() =>
        {
            currentCountDown--;
            updateTimer();
            if (currentCountDown == 0)
            {
                clearInterval(countDownInterval);
                if (onTimeoutAction)
                    onTimeoutAction();
            }
        }, 1000);
    }

    function updateTimer()
    {
        const circleDasharray = `${(
            currentCountDown / countDown * FULL_CIRCLE
        ).toFixed(0)}px 113px`;

        if (circleProgress)
        circleProgress.setAttribute("stroke-dasharray", circleDasharray);
    }

    export function clearCountDown()
    {
        clearInterval(countDownInterval);
        currentCountDown = 0;
        onTimeoutAction = null;
    }

</script>

{#if currentCountDown}
<div id="countdown">
    <svg>
      <circle bind:this={circleProgress} r="18" cx="40" cy="40"></circle>
    </svg>
    <!--<div id="countdown-number">{currentCountDown}</div>-->
  </div>
{/if}

<style>
    #countdown {
    position: absolute;
    margin: auto;
    margin-left: -6px;
    margin-top: -10px;
    top: 5px;
    height: 80px;
    width: 80px;
    text-align: center;
    pointer-events: none;
    }

    #countdown-number {
    font-size: 18pt;
    font-weight: bolder;
    color: black;
    display: inline-block;
    line-height: 80px;
    pointer-events: none;
    }

    svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 80px;
    transform: rotateY(-180deg) rotateZ(-90deg);
    pointer-events: none;
    }

    svg circle {
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 5px;
    stroke: black;
    fill: none;
    pointer-events: none;
    }
</style>